import styled from "styled-components";
import media from "styled-media-query";

import Form from "components/Form";

export const Container = styled(Form)`
  ${media.greaterThan("large")`
    transform: translateX(-12%);
  `}

  ${media.greaterThan("huge")`
    transform: translateX(-8%);
  `}
`;
